exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".button:hover{cursor:pointer}.button.disabled{pointer-events:none}.button:active{transform:scale(0.95);box-shadow:3px 2px 22px 1px rgba(0,0,0,0.24)}.mr-8{margin-right:0.8rem}\n", ""]);

